module.exports = __webpack_public_path__ + "img/horizontal_4_4_9006.4011e5dd.png";